import { render, staticRenderFns } from "./user-menu.component.vue?vue&type=template&id=0e9ff064&"
import script from "./user-menu.component.vue?vue&type=script&lang=ts&"
export * from "./user-menu.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports